// filepath: /home/kshitij/BlippAI/src/components/SuggestedQuestions.jsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const SuggestedQuestions = ({ 
  questions, 
  onQuestionClick, 
  isDarkMode,
  language = 'en' 
}) => {
  if (!questions || questions.length === 0) return null;

  const isRTL = language === 'ar';

  return (
    <AnimatePresence>
      <div 
        className="w-full mb-2"
        style={{ direction: isRTL ? 'rtl' : 'ltr' }}
      >
        <p className={`text-sm mb-2 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
          You may also want to know about:
        </p>
        <div className="flex flex-wrap gap-2">
          {questions.map((question, index) => (
            <motion.button
              key={index}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2, delay: index * 0.05 }}
              onClick={() => onQuestionClick(question)}
              className={`px-3 py-1.5 text-sm rounded-lg transition-all duration-200 text-left ${
                isDarkMode 
                  ? 'bg-gray-800 hover:bg-gray-700 text-gray-300 hover:text-white border border-gray-700' 
                  : 'bg-gray-100 hover:bg-gray-200 text-gray-800 border border-gray-200'
              }`}
              style={{
                boxShadow: isDarkMode ? '0 1px 2px rgba(0,0,0,0.3)' : '0 1px 2px rgba(0,0,0,0.1)'
              }}
            >
              {question}
            </motion.button>
          ))}
        </div>
      </div>
    </AnimatePresence>
  );
};

export default SuggestedQuestions;